// Runtime hand state + the decision point the UI binds to. ENGINE_DESIGN.md §1 (schema/hand-state.ts).
import { z } from 'zod';
import { PositionSchema, StreetSchema } from './position';
import { CardIndexSchema, BoardSchema } from './primitives';
import { ActionKindSchema, ActionSchema } from './action';
import { ArchetypeIdSchema } from './archetype';
import { ScenarioSpecSchema } from './scenario';
export const PlayerStateSchema = z.object({
    seat: z.number().int().nonnegative(),
    position: PositionSchema,
    stack: z.number().nonnegative(),
    committedThisStreet: z.number().nonnegative(),
    committedTotal: z.number().nonnegative(),
    folded: z.boolean(),
    allIn: z.boolean(),
    /** hero + revealed-at-showdown only. */
    holeCards: z.tuple([CardIndexSchema, CardIndexSchema]).optional(),
    archetypeId: ArchetypeIdSchema.optional(),
});
/** main + side pots, each with its eligibility list. */
export const PotSchema = z.object({
    amount: z.number().nonnegative(),
    eligibleSeats: z.array(z.number().int().nonnegative()),
});
export const HandPhaseSchema = z.enum(['dealing', 'acting', 'showdown', 'complete']);
export const HandStateSchema = z.object({
    handId: z.string(),
    spec: ScenarioSpecSchema,
    street: StreetSchema,
    board: BoardSchema,
    players: z.array(PlayerStateSchema),
    buttonSeat: z.number().int().nonnegative(),
    pots: z.array(PotSchema),
    /** to-amount to match this street. */
    currentBet: z.number().nonnegative(),
    minRaiseTo: z.number().nonnegative(),
    /** seat to act; null = street closed. */
    toAct: z.number().int().nullable(),
    history: z.array(z.object({ street: StreetSchema, action: ActionSchema })),
    phase: HandPhaseSchema,
});
export const LegalActionSchema = z.object({
    kind: ActionKindSchema,
    min: z.number().nonnegative().optional(),
    max: z.number().nonnegative().optional(),
});
/** A paused point where hero must act - what the UI binds to (ENGINE_DESIGN.md §1). */
export const DecisionPointSchema = z.object({
    handId: z.string(),
    street: StreetSchema,
    decisionIndex: z.number().int().nonnegative(),
    state: HandStateSchema,
    legal: z.array(LegalActionSchema),
    pot: z.number().nonnegative(),
    toCall: z.number().nonnegative(),
    effectiveStack: z.number().nonnegative(),
    spr: z.number().nonnegative(),
});
//# sourceMappingURL=hand-state.js.map